import React, { useEffect, useState } from "react";
import { getUserCredentials } from "../../api/usuarioApi";
import { getAdminById } from "../../api/AdminApi";
import Feriados from "./opciones/Feriados";
import Insumos from "./opciones/Insumos";
import Medicamentos from "./opciones/Medicamentos";
import Procedimientos from "./admin/Procedimientos";

export default function Opciones() {
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(undefined);
  const [hasPermission2, setHasPermission2] = useState(undefined);

  useEffect(() => {
    const checkPermission = async () => {
      setLoading(true);
      try {
        const user = await getUserCredentials();
        const admin = await getAdminById(user.IdUsuario);
        if (admin[0].opciones === "false") {
          setHasPermission(false);
        } else {
          setHasPermission(true);
        }
        if (admin[0].cierres === "false") {
          setHasPermission2(false);
        } else {
          setHasPermission2(true);
        }
      } catch {
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };
    checkPermission();
  }, []);

  if (loading)
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
        <div
          style={{
            width: 38,
            height: 38,
            border: "4px solid #ddd",
            borderTop: "4px solid #1569c9ff",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
        <span style={{ marginLeft: 14, color: "#444", fontSize: 18 }}>Cargando...</span>
        <style>{`@keyframes spin {0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}`}</style>
      </div>
    );

  if (hasPermission === false)
    return (
      <div style={{ textAlign: "center", marginTop: 50 }}>
        <h3>No tiene permisos para ver esta información.</h3>
      </div>
    );

  if (hasPermission !== true) return null;

  return (
    <div className="row g-4">
      <div className="col-xl-6 col-lg-6">
        <Feriados />
      </div>
      <div className="col-xl-6 col-lg-6">
        <Medicamentos />
      </div>
      <div className="col-xl-6 col-lg-6">
        <Insumos />
      </div>
      <div className="col-xl-6 col-lg-6">
        <Procedimientos showTarifa={hasPermission2} />
      </div>
    </div>
  );
}